/* eslint-disable no-redeclare */
import { z } from 'zod';

export const LastName = z.string().min(2, {
  message: 'This field is required. Please fill it with valid information.',
});

export type LastName = z.infer<typeof LastName>;
